module.exports = __webpack_public_path__ + "static/media/damage-maps.9c5c677a.svg";